<template>
  <div class="flex">
    <slot></slot>
    <q-btn
      class="filter-icon q-ml-auto btn--no-hover"
      :class="{ active: showFilters }"
      icon="filter_alt"
      flat
      size="md"
      :ripple="false"
      @click="showFilters = !showFilters"
    >
      <q-tooltip>{{ showFilters ? 'Hide filters' : 'Show filters' }}</q-tooltip>
    </q-btn>
    <q-btn
      v-if="mode === 'read'"
      flat
      size="md"
      style="width: 30px"
      icon="edit"
      class="btn--no-hover"
      @click="goToRegistration($event)"
    >
      <q-tooltip>Edit zones</q-tooltip>
    </q-btn>
  </div>
  <div v-if="showFilters" class="row no-wrap full-width q-mt-sm q-mb-xs q-col-gutter-sm">
    <div v-if="$route.query?.zoneId" class="col">
      <q-input
        v-model="filters.id"
        label="ID"
        outlined
        dense
        clearable
        @update:model-value="filterTable()"
        class="q-mb-sm"
      ></q-input>
    </div>
    <div class="col">
      <q-select
        v-model="filters.status"
        :options="[
          { label: 'Completed', value: 'completed' },
          { label: 'In progress', value: 'inprogress' },
          { label: 'Failed', value: 'failed' },
          { label: 'Removed', value: 'removed' },
        ]"
        emit-value
        map-options
        options-dense
        @update:model-value="reloadTable"
        label="Status"
        clearable
        outlined
        dense
        class="q-mb-sm"
      ></q-select>
    </div>
    <div class="col">
      <q-input
        v-model="filters.name"
        label="Zone name"
        @update:model-value="filterTable"
        outlined
        dense
        clearable
        class="q-mb-sm"
      ></q-input>
    </div>
    <div class="col">
      <q-select
        v-model="filters.license"
        :options="[
          { label: 'Free', value: 'free' },
          { label: 'Enterprise', value: 'enterprise' },
          { label: 'China', value: 'china' },
        ]"
        emit-value
        map-options
        options-dense
        label="License"
        @update:model-value="reloadTable()"
        outlined
        dense
        clearable
        class="q-mb-sm"
      ></q-select>
    </div>
    <div class="col">
      <q-select
        v-model="filters.dns_enabled"
        :options="[
          { label: 'Enabled', value: true },
          { label: 'Disabled', value: false },
        ]"
        map-options
        options-dense
        @update:model-value="reloadTable()"
        label="DNS"
        outlined
        dense
        clearable
        class="q-mb-sm"
      ></q-select>
    </div>
  </div>
  <ZonesTable
    :registrationId="registrationId"
    :registrationData="registrationData"
    ref="zonesTable"
    :filters="filters"
    :mode="mode"
    :expanded="expanded"
    @toggleExpanded="$emit('toggleExpanded', $event)"
    @reassign="$emit('reassign', $event)"
    @confirmDeleteZone="$emit('confirmDeleteZone', $event)"
  >
    <template #expand> <slot name="expand"></slot></template>
  </ZonesTable>
</template>

<script>
import ZonesTable from '@/shared/components/ZonesTable.vue';
import { supportCntrlClick } from '@/shared/helpers';

export default {
  name: 'ZonesWidget',
  components: {
    ZonesTable,
  },
  props: {
    registrationId: {
      type: String,
    },
    registrationData: {
      type: Object,
    },
    mode: {
      type: String,
    },
    expanded: {
      type: Array,
    },
  },
  data() {
    return {
      showFilters: false,
      timeout: undefined,
      filters: {
        id: undefined,
        registrationId: this.registrationId,
        digitalService: undefined,
        infraService: undefined,
        name: undefined,
        license: undefined,
        dns_enabled: undefined,
        dateFrom: undefined,
        dateTo: undefined,
        status: undefined,
      },
    };
  },
  methods: {
    filterTable() {
      if (this.timeout) clearTimeout(this.timeout);
      this.timeout = setTimeout(async () => {
        this.reloadTable();
      }, 1500);
    },
    reloadTable() {
      this.$refs.zonesTable.reload();
    },
    goToRegistration(event) {
      supportCntrlClick(
        event,
        `/my-portfolio/${this.registrationData.digitalServiceApm}/registration/${this.registrationId}`,
      );
    },
  },
  mounted() {
    if (this.$route.query?.zoneId) {
      this.showFilters = true;
      this.filters.id = this.$route.query?.zoneId;
    }
    this.reloadTable();
  },
};
</script>
